import { call, fork, select, take } from 'redux-saga/effects';
import { makeRequest } from './makeRequest';
import { debug, error } from '../utils/logger';
import { CLICKSTREAM_ACTION } from '../actions/analyticsActions';
import { getGroundhogClicksteamEventRoute } from '../utils/apiRoutes';

/**
 * Handle a GROUNDHOG_CLICKSTREAM_ACTION and send off the event
 *  to Groundhog
 */
export function* handleClickstreamEventSaga() {
    let action = {};

    if (window.envVars.groundhogClickTracking === false) {
        debug("Groundhog Clickstream feature disabled");
        return;
    }

    while (action = yield take(CLICKSTREAM_ACTION)) {
        debug(`Processing Groundhog Clickstream Data: ${action.payload}`);

        yield fork(fireClickstreamEventSaga, action.payload);
    }
}

/**
 * Make the request to groundhog
 * @param clickEventData
 */
export function* fireClickstreamEventSaga(clickEventData) {
    const route = getGroundhogClicksteamEventRoute(yield select(), clickEventData);
    return yield call(makeRequest, route);
}

export default [ handleClickstreamEventSaga ];
